import WebimHotPanel from './src/index';

export default WebimHotPanel;
